module.exports = __webpack_public_path__ + "img/PRESENTED BY_.a3ee277e.png";